import React, {useEffect} from 'react';
import * as actions from '../actions';

export function DashboardOperationsPersonnel() {

	useEffect(() => { actions.setHeader({
		key: 'dashboardOperationsHeader',
		component: (
			<header><ul className="menu"><li><a className="button" href="dashboardOperationsJobs"><span><span className="statusDot"></span>Jobs</span></a></li><li><a className="button" href="dashboardOperationsCalendar"><span>Calendar</span></a></li><li><a className="button on" href="dashboardOperationsPersonnel"><span>Personnel</span></a></li></ul></header>
		)
	});

	return () => {
		actions.deleteHeader({ key: 'dashboardOperationsHeader'});
	}
	}, []);

	return <div className='dashboard operations'>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span>B. DAVIS<span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''></div>
		</section>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span>B. EMERY<span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''></div>
		</section>

		<section className='expander expanded'>
			<header><button tabIndex={1}><span>N. NICKERSON <span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>INSTALL <span className='subtitle'>$6,650</span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
					</header>
					<div>
						<div className='inner clearfix'>
							<table className='sortable interactive' cellPadding='0' cellSpacing='0'>
								<thead>
									<tr>
										<td></td>
										<td className='sorted date'>Date</td>
										<td className=''>Legacy ID</td>
										<td className='name'>Client</td>
										<td className='address'>Address</td>
										<td className='date'>Delivers</td>
										<td className='price'>Install Budget</td>
										<td className='count'>Duration</td>
										<td className=''>Occupied?</td>
										<td className='action'>Bin Report</td>
										<td className='action'></td>
										<td></td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td></td>
										<td className='date'>05/29/20</td>
										<td className=''>000000</td>
										<td className='name'>Carol Danvers</td>
										<td className='address'>624 S. Sagewood Dr</td>
										<td className='date'>05/27/20</td>
										<td className='price'>$2,250</td>
										<td className='count'>2 days</td>
										<td className=''>No</td>
										<td className='action'><button className='icon iconOnly print'><span></span></button></td>
										<td className='action navigate'></td>
										<td></td>
									</tr>
									<tr>
										<td></td>
										<td className='date'>05/30/20</td>
										<td className=''>000000</td>
										<td className='name'>Tina Savon</td>
										<td className='address'>10 Inception Way NE</td>
										<td className='date'>05/28/20</td>
										<td className='price'>$4,500</td>
										<td className='count'>2 days</td>
										<td className=''>No</td>
										<td className='action'><button className='icon iconOnly print'><span></span></button></td>
										<td className='action navigate'></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>

				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>SERVICE <span className='subtitle'>4 hours</span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
					</header>
					<div>
						<div className='inner clearfix'>
							<table className='sortable interactive' cellPadding='0' cellSpacing='0'>
								<thead>
									<tr>
										<td></td>
										<td className='sorted date'>Date</td>
										<td className=''>Legacy ID</td>
										<td className='name'>Client</td>
										<td className='address'>Address</td>
										<td className='date'></td>
										<td className='price'>Issues</td>
										<td className='count'>Estimate</td>
										<td className=''>Occupied?</td>
										<td className='action'>Bin Report</td>
										<td className='action'></td>
										<td></td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td></td>
										<td className='date'>05/28/20</td>
										<td className=''>000000</td>
										<td className='name'>Davis Smith</td>
										<td className='address'>287 S. Ferndale Pl</td>
										<td className='date'></td>
										<td className='price'>12</td>
										<td className='count'>4 hours</td>
										<td className=''>No</td>
										<td className='action'><button className='icon iconOnly print'><span></span></button></td>
										<td className='action navigate'></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>
			</div>
		</section>

		<section className='expander collapsed'>
			<header><button tabIndex={1}><span>T. TUA<span className='subtitle'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''></div>
		</section>
	</div>;
}